import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { service } from '@ember/service';
import { next } from '@ember/runloop';
import { isPresent } from '@ember/utils';

/*
  args
    - task
    - displayJournalInfo
    - onTaskSaving({ saving: boolean, task: Task })
    - onTaskSaveError({ task: V2Task, error: error })
    - onTaskSaved(task)
    - onEditTask(task)
*/

export default class extends Component {
  constructor(owner, args) {
    super(owner, args);

    this.setSelectedResult(
      this.taskService.resultsById[this.taskAction?.resultIds?.[0]],
    );
  }

  @service currentUser;
  @service fundsService;
  @service journalService;
  @service taskService;

  @tracked standinResultTrigger = true;
  @tracked standinUserTrigger = true;
  @tracked standinNotesTrigger = true;
  @tracked selectedResult = null;
  @tracked saving = false;
  @tracked saveError = false;

  get leftBarColor() {
    if (this.saveError) {
      return 'bg-danger';
    } else if (this.args.task.completedDate) {
      return 'bg-success';
    } else {
      return 'bg-secondary';
    }
  }

  get taskAction() {
    if (this._taskAction) {
      return this._taskAction;
    }
    return (this._taskAction =
      this.taskService.actionsById[this.args.task.actionId]);
  }

  get availableResults() {
    if (this._availableResults) {
      return this._availableResults;
    }
    return (this._availableResults =
      this.taskService.availableResultsByActionId[this.taskAction?.id] || []);
  }

  get hasMultipleAvailableResults() {
    return this.availableResults.length > 1;
  }

  get isOverdue() {
    return this.args.task.dueDate && this.args.task.dueDate < new Date();
  }

  get hasNotes() {
    return isPresent(this.args.task.notes);
  }

  get hasAssignedUsers() {
    return isPresent(this.args.task.assignedUserIds);
  }

  get isAssignedToCurrentUser() {
    return this.args.task.assignedUserIds.some((x) => x == this.currentUser.id);
  }

  get journalLabel() {
    let { journalStageId } = this.args.task;
    return this.journalService.stageInfoById(journalStageId)?.journalInfo
      .journal.label;
  }

  get journalStageName() {
    let stageInfo = this.journalService.stageInfoById(
      this.args.task.journalStageId,
    );
    return stageInfo?.stage.name;
  }

  @action
  setSelectedResult(result) {
    this.selectedResult = result;
  }

  @action
  removeStandin(name) {
    this[`standin${name}Trigger`] = false;
  }

  @action
  handleTaskSaving(args) {
    if (args.saving && this.saveError) {
      this.saveError = false;
    }
    this.args.onTaskSaving?.(args);
  }

  @action
  handleTaskSaveError(args) {
    this.saveError = true;
    this.args.handleTaskSaveError?.(args);
  }

  @action
  closeDropdown(dropdown) {
    next(() => {
      dropdown.actions.close();
    });
  }
}
